/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

const es_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

const de_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

const nl_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

const fr_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

const it_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

const pt_br2_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

const pt_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

const ja_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

const zh_f1_budget_pts_short = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pts`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_pts_short = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_pts_short(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_pts_short", locale)
	if (locale === "en") return en_f1_budget_pts_short(inputs)
	if (locale === "es") return es_f1_budget_pts_short(inputs)
	if (locale === "de") return de_f1_budget_pts_short(inputs)
	if (locale === "nl") return nl_f1_budget_pts_short(inputs)
	if (locale === "fr") return fr_f1_budget_pts_short(inputs)
	if (locale === "it") return it_f1_budget_pts_short(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_pts_short(inputs)
	if (locale === "pt") return pt_f1_budget_pts_short(inputs)
	if (locale === "ja") return ja_f1_budget_pts_short(inputs)
	return zh_f1_budget_pts_short(inputs)
};